angular
	.module 'App.Repository'
	.factory 'TrackingCategoryRepository', [
		'BaseRepository',
		(BaseRepository) ->
			class TrackingCategoryRepository extends BaseRepository
				@resource = '/tracking_categories'
				@isRestricted = true

			return new TrackingCategoryRepository
	]
